module.exports = __webpack_public_path__ + "static/img/agent-1.68a99b4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/agent-1.jpg
// module id = /3Qc
// module chunks = 1